import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import { IModelInfo } from "../../entities/nu-model-info";

@Component
export default class ModelDirectory extends Vue {


    @Prop()
    value: IModelInfo;

}



// WEBPACK FOOTER //
// ./ClientApp/components/new-model-editor/new-model-editor.ts